import { Component, OnInit, Input, ComponentFactoryResolver, Injector, ComponentRef, ApplicationRef, Output, EventEmitter } from '@angular/core';
import { IncidenciaComponent } from '../incidencia/incidencia.component';

/**
 * Component per mostrar el marcador d'una incidència a la llista d'incidències de l'aplicació
 */
@Component({
  selector: 'app-incidencia-llista',
  templateUrl: './incidencia-llista.component.html',
  styleUrls: ['./incidencia-llista.component.css']
})
export class IncidenciaLlistaComponent implements OnInit {

  /**
   * Feature que conté les propietats per crear el marcador
   */
  @Input() feature;

  /**
   * Capa a la qual pertany el marcador
   */
  @Input() layer;

  /**
   * Instància de mapa de l'aplicació
   */
  @Input() map: google.maps.Map; 

  /**
   * Finestra d'informació del mapa 
   */
  @Input() infowindow: google.maps.InfoWindow; 

  /**
   * Emet un valor si es clica a un marcador per centrar el mapa en aquest
   */
  @Output() clickEmitter = new EventEmitter<any>();

  /**
   * Conté les propietats del feature
   */
  properties; 

  /**
   * Url de la icona a mostrar
   */
  iconUrl: string; 

  /**
   *  Carretera on s'ha produt la incidència
   */
  road: string; 

  /**
   * Punt kilomètric inicial de la incidència 
   */
  start_kp: string;

  /**
   * Punt kilomètric final de la incidència 
   */
  end_kp: string; 

  /**
   * Ciutat on s'ha produit la incidència
   */
  city: string;

  /**
   * Causa per la qual s'ha produit la incidència
   */
  cause: string;

  /**
   * Comentaris sobre la incidència
   */
  comments: string;
  
  /**
   * Direcció de la carretera en la qual s'ha produit la incidència
   */
  direction: string;

  /**
   * Font d'informació 
   */
  source: string;

  /**
   * Nivell de perill de la incidència
   */
  levelOfService: string;

  /**
   * Identificador de la causa d'incidència meteorològica
   */
  meteoId: string;

  /**
   * Indica per cada identificador d'incidència meteorològica el seu nom en castellà
   */
  meteoIds: Map<string,string> = new Map([["20","Niebla"],["28","Cadenas"],["21","Hielo"],["42","Inundaciones"],["26","Lluvia"],["27","Nieve"],["33","Viento"]])

  /**
   * Constructor del component
   * @param {ComponentFactoryResolver} resolver Carrega components dinàmicament per injectar-los a la finestra d'informació de l'aplicació 
   * @param {Injector} injector Injecta informació als components carregats dinàmicament
   * @param {ApplicationRef} appRef Manté una referència a elements de l'aplicació
   */
  constructor(private resolver: ComponentFactoryResolver, private injector: Injector, private appRef: ApplicationRef) { }

  /**
   * @ignore
   */
  compRef: ComponentRef<any>;

  

  /**
   * Retorna la URL de la icona del marcador depenent de a quina capa pertany
   * @returns {string} URL de la icona del marcador depenent de a quina capa pertany
   */
  getUrl(){
    var url: string;
    if(this.layer === "METEO"){
      var nomCausa = this.meteoIds.get(this.meteoId);
      url = 'assets/img/' + nomCausa + 'Lista';
    }
    else url = 'assets/img/' + this.layer;

    return url + '.svg';

  }


  /**
   * Obre la finestra d'informació de la incidència
   */
  showMarker(){
    var coordinates = new google.maps.MVCObject();
    coordinates.set("position", new google.maps.LatLng(this.feature.geometry.coordinates[1],this.feature.geometry.coordinates[0]));
    coordinates.set("anchorPoint", new google.maps.Point(0, -61));
    this.infowindow.setContent(this.loadInfoWindow(this.feature, this.layer));
    this.infowindow.open(this.map, coordinates);
    this.clickEmitter.emit();
    this.showWindow();
  }

  /**
   * Centra el mapa en la incidència seleccionada i mostra la seva finestra d'informació
   */
  showWindow(){
    var coordinates = new google.maps.MVCObject();
    coordinates.set("position", new google.maps.LatLng(this.feature.geometry.coordinates[1],this.feature.geometry.coordinates[0]));
    this.map.panTo(coordinates.get("position"));
    this.map.setZoom(15);
  }

  /**
   * Genera i retorna el contingut d'un component que conté la informació a mostrar a la infowindow
   * @param {json} feature Conté les dades del marcador al qual li volem afegir la finestra d'informació
   * @param {json} layer Identificador de la capa a la qual pertany el feature 
   * @returns {HTMLDivElement} HTML amb informació a mostrar a la finestra
   */
  loadInfoWindow(feature, layer): HTMLDivElement{
    if(this.compRef) this.compRef.destroy();
    var compFactory;
    compFactory = this.resolver.resolveComponentFactory(IncidenciaComponent);
    this.compRef = compFactory.create(this.injector);
    this.compRef.instance.feature = feature;
    this.compRef.instance.layer = layer;
    this.appRef.attachView(this.compRef.hostView);
    let div = document.createElement('div');
    div.appendChild(this.compRef.location.nativeElement);
    return div;
  }

  /**
   * Inicialitza les propietats de la incidència
   */
  ngOnInit() {
    this.properties = this.feature.properties;
    this.road = this.properties.road;
    this.start_kp = this.properties.start_kp;
    this.end_kp = this.properties.end_kp;
    this.city = this.properties.city;
    this.cause = this.properties.cause[0] +
    this.properties.cause.substring(1).toLowerCase();
    this.meteoId = this.properties.causeId;
    this.levelOfService = this.properties.levelOfService;
    this.iconUrl = this.getUrl();
    this.source = this.properties.source;
    this.comments = this.properties.comments;
    this.direction = this.properties.direction;
  }

}
